// src/Components/common/PublicPageHead.js
//
// Applies the per-page title and description from publicPageMeta to the
// current public route, and the home page's structured data. Mounted once in
// Routers, AFTER App's default <CustomHead />, so it wins for these routes;
// a page that renders its own CustomHead mounts later still and wins over
// this. Renders nothing on routes without an entry.

import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import CustomHead from "./CustomHead";
import {
  buildHomeStructuredData,
  getPublicPageMeta,
} from "../../utils/seo/publicPageMeta";

const PublicPageHead = () => {
  const { pathname } = useLocation();
  const meta = getPublicPageMeta(pathname);

  if (!meta) return null;

  const isHome = (pathname.replace(/\/+$/, "") || "/") === "/";

  return (
    <>
      <CustomHead title={meta.title} description={meta.description} />
      {isHome && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(buildHomeStructuredData(window.location.origin))}
          </script>
        </Helmet>
      )}
    </>
  );
};

export default PublicPageHead;
